import { PartDetailsDialog } from "../modules/StoresModule/Components/PartList/PartDetailsDialog"

const EVENTS_KEYBOARD_SHORTCUTS = { // keyboard events combination for forms or others.
	CANCEL : "Escape", //cancel edition 
	SAVE_IN_DRAFT_OR_CONTINUE_EDIT : "event.ctrlKey && event.key === 's'", // save the data in the form but keeping me in edition mode to continue editing the form
	save : "ctrl + g" // save all data in the form and finalize the edition completelly
}

export const CONTEXT_TYPES = {
	PART: "part",
	PROFILE: "profile",
	PART_IMAGE: "part_image",
	NOTIFICATIONS: "notifications" ,
	TASKBAR: "taskbar",
}

export const LABELS = {
	DRAFT: "Unsaved",
	EDITION_MODE: "Editing"
}

export const HTTP_RESPONSE_CODES ={
	SUCCESS : 200,
	CREATED : 201,
	UPDATED : 204,
	DELETED : 204,
	VALIDATIONS_FAILED : 301,
	VERSION_CONFLICT : 409,

}
